import React, { FC } from 'react';
import { LocationInfoCountrySelectProps } from './LocationInfoCountrySelectProps';
import CustomSelect from '../../../common/CustomSelect';
import useTranslation from '../../../hooks/useTranslation';
import { useFormContext } from 'react-hook-form';

const LocationInfoCountrySelect: FC<LocationInfoCountrySelectProps> = ({
  countries,
  onCountryChange,
  disabled,
}) => {
  const { setValue } = useFormContext();
  const t = useTranslation();
  return (
    <CustomSelect
      dataTestID={'country-select'}
      optionsArray={countries.reduce((acc, country) => {
        return { ...acc, [country.countryId]: country.countryName };
      }, {})}
      customOnChange={(e) => {
        onCountryChange(e as Event);
        setValue('businessUnitId', null);
      }}
      name={'countryCode'}
      required
      disabled={disabled}
      label={t('common.country')}
    />
  );
};

export default LocationInfoCountrySelect;
